import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginRepository } from "../../repository/AdminDashboard/LoginRepository";
import toast, { Toaster } from "react-hot-toast";

// Create the context
const StateContext = createContext();

const initialState = {
  countryCode: "+98",
};

// Define the LoginContext component
const LoginContext = ({ children }) => {
  // State variables
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");

  // Navigation hook
  const navigate = useNavigate();

  // Helper function to check if a string is numeric and has a specified count of digits
  function isNumeric(str, count) {
    const regex = new RegExp(`^\\+?\\d{${count}}$`);
    return regex.test(str.trim());
  }

  // Function to send phone number and code to get SMSId
  const sendNumber = async (num, code) => {
    setLoading(true);
    try {
      const data = await LoginRepository.getmobile(
        num,
        initialState.countryCode,
        code
      );

      // Handle the response data
      if (data.code === 1) {
        setLoading(false);
        localStorage.setItem("smsId", data.SMSId);
        navigate("otp");

        // Show success toast

        setTimeout(() => {
          toast.success(data.message, {
            className: "text-12 text-dark-blue-200",
          });
        }, 1500);

      } else if (data.code === 0) {
        setLoading(false);

        // Show error toast
        toast.error(data.message, {
          className: "text-12 text-dark-blue-200",
        });

      }
    } catch (error) {
      console.error("خطا در اتصال به سرور", error);
      setLoading(false);
    }
  };

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate and process the phone number
    if (isNumeric(phoneNumber, 11)) {
      const cleanedPhoneNumber = phoneNumber.trim().replace(/^0+/, "");
      if (!code || code.length === 0) {
        toast.error("رمز ورود را وارد کنید", {
          className: "text-12 text-dark-blue-200",
        });
      } else {
        await sendNumber(cleanedPhoneNumber, code);
      }
    } else {
      // Show error toast for an invalid phone number
      toast.error("شماره را صحیح وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    // Validate credentials here
  };

  // Function to handle password change
  const handlePasswordChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  // Function to handle code change
  const handleCodeChange = (event) => {
    setCode(event.target.value);
  };

  // Provide the context value to the children components
  return (
    <StateContext.Provider
      value={{
        handleSubmit,
        handlePasswordChange,
        phoneNumber,
        loading,
        code,
        handleCodeChange,
      }}>
      {children}
    </StateContext.Provider>
  );
};

// Function to use the LoginContext in components
function LoginUseContext() {
  return React.useContext(StateContext);
}

// Export the LoginUseContext and LoginContext
export { LoginUseContext };
export default LoginContext;
